//make jQuery accessible globally.
window.jQuery = require('jquery');
window.$ = jQuery;

window.Popper = require('popper.js');
Popper.default.Defaults.modifiers.computeStyle.gpuAcceleration = false;
require('bootstrap');
const debounce = require('lodash/debounce');
const waypoints = require('./waypoints.js');
const { isInsideElement } = require('../lib/utils/dom-utils.js');
const { scrollToTop } = require('../lib/utils/scroll-utils.js');

import { loadScripts, loadScrollDelayedScripts } from './index-module.js';

window.addEventListener("DOMContentLoaded", () => {
    const carouselSelectors = [
        ".fund-carousel-block__main--desktop:not(.fund-carousel-block__main-au-campaign)",
        "ve-relatedmediablock",
        "[data-template*='Carousel']",
        ".slider-for",
        ".recommended-insights__list",
        ".carousel-block__main--desktop",
        ".carousel-wrapper__main--desktop",
        ".more-from-category__main--desktop",
        ".latest-digital-grid__main--desktop"
    ];
    let carouselBool = carouselSelectors.some(selector => document.querySelector(selector));

    (async () => {
        await loadScripts(carouselBool);
    })();

    const loadScriptsScrollListener = debounce(() => {
        const heightOffset = window.innerHeight / 8;
        const ScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
        if (ScrolledTop > heightOffset) {
            (async () => {
                await loadScrollDelayedScripts(carouselBool);
            })();
            return window.removeEventListener("scroll", loadScriptsScrollListener);
        }
    }, 100);
    window.addEventListener("scroll", loadScriptsScrollListener);
    loadScriptsScrollListener();

    initCoreComponents();

    loadComponentsByCondition();
});

function initCoreComponents() {
    $('.recommended-insights .tab-nav__link').on('shown.bs.tab', function() {
        const id = $(this).index('.recommended-insights .tab-nav__link');
        $('.tab-nav__list li').each(function(index) {
            $(`.recommended-insights__actions-${index}`).css('display', 'none');
        });
        $(`.recommended-insights__actions-${id}`).css('display', 'block');
    });

    $(document).on('click.bs.dropdown.data-api', '.site-header__mobile-submenu', (event) => {
        if (!isInsideElement(event, 'a') && !isInsideElement(event, 'button')) {
            event.stopPropagation();
        }
    });

    $(document).on('click.bs.dropdown.data-api', '.site-header__mobile-submenu-toggle', () => {
        scrollToTop();
    });

    $(document).on('click.bs.dropdown.data-api', '.site-header__submenu .list-group-item-action', (event) => {
        event.stopPropagation();
    });

    $(document).on('click.bs.dropdown.data-api', '.site-header__submenu', (event) => {
        if (!isInsideElement(event, 'a') && !isInsideElement(event, 'button')) {
            event.stopPropagation();
        }
    });

    waypoints.init();
    waypoints.sectionHeaderInit();
    waypoints.tableHeaderInit();
}

function loadComponentsByCondition() {
    
    if (document.querySelector('.site-header__submenu-action, .site-header .navbar-toggler')) {
        import(/* webpackChunkName: "header-components" */ './components/header.js')
            .then(module => module.default && module.default());
    }
    
    setTimeout(() => {
        if (document.querySelector('.alert-bar__ctalink, #site-header-search, #gateway-modal')) {
            import(/* webpackChunkName: "alerts-modals" */ './components/alerts-modals.js')
                .then(module => module.default && module.default());
        }
        
        if (document.querySelector('.widget.dropdown, .form-country-container')) {
            import(/* webpackChunkName: "widgets" */ './components/widgets.js')
                .then(module => module.default && module.default());
        }
    }, 1000);
    
    let scrollFeaturesLoaded = false;
    let attachmentBlocksLoaded = false;
    
    const scrollHandler = debounce(() => {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        const triggerHeight = window.innerHeight / 4;
        
        if (scrollPosition > triggerHeight) {
            // Scroll features
            if (!scrollFeaturesLoaded && document.querySelector('.scroll-to-top')) {
                scrollFeaturesLoaded = true;
                import(/* webpackChunkName: "scroll-features" */ './components/scroll-features.js')
                    .then(module => module.default && module.default());
            }
            
            // Attachment blocks
            if (!attachmentBlocksLoaded && document.querySelector('.attachment-block')) {
                attachmentBlocksLoaded = true;
                import(/* webpackChunkName: "attachment-blocks" */ './components/attachment-blocks.js')
                    .then(module => module.default && module.default());
            }
            
            if (scrollFeaturesLoaded && attachmentBlocksLoaded) {
                window.removeEventListener('scroll', scrollHandler);
            }
        }
    }, 200);
    
    window.addEventListener('scroll', scrollHandler);
    
    setTimeout(() => {
        if (!scrollFeaturesLoaded && document.querySelector('.scroll-to-top')) {
            scrollFeaturesLoaded = true;
            import(/* webpackChunkName: "scroll-features" */ './components/scroll-features.js')
                .then(module => module.default && module.default());
        }
        
        if (!attachmentBlocksLoaded && document.querySelector('.attachment-block')) {
            attachmentBlocksLoaded = true;
            import(/* webpackChunkName: "attachment-blocks" */ './components/attachment-blocks.js')
                .then(module => module.default && module.default());
        }
    }, 3000);
}